import React, { useRef, useState, Component } from 'react'
import { useParams } from 'react-router-dom'
import { connect } from 'react-redux'
import { useSelector } from "react-redux"
import { firestoreConnect } from 'react-redux-firebase'
import { compose } from 'redux'
import { updateprofile } from '../../store/actions/authActions'
import firebase from "firebase/compat/app";
import 'firebase/compat/firestore'
import { useNavigate } from 'react-router-dom';
import { styles } from '../layout/styles'
import { Button, Card, CardBody, Table, Modal, Image } from 'react-bootstrap'
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { grey } from '../../config/Colors';


function UpdateProfile(props)  {
    const navigate = useNavigate();
    const firstnameRef = useRef()
    const lastnameRef = useRef()
    const genderRef = useRef()
    const dateofbirthRef = useRef()
    const [profileimage, setprofileimage] = useState(null);
    const entity = props.profile;
    const dobDefault = entity?.dateofbirth?.toDate().getFullYear() + '-' + (entity?.dateofbirth?.toDate().getMonth() + 1) + '-' + entity?.dateofbirth?.toDate().getDate();  
    const initailemail = props.auth.email;
    const [loading, setLoading] = useState(false)
    const [imageURL, setimageURL] = useState("");
    let profileimageurl = (props.profile.profileimageurl) ? props.profile.profileimageurl : "";

    const [showMsg, setshowMsg] = useState(false);
    const handleCloseMsg = () => {setshowMsg(false); navigate('/');}
    function handleShowMsg() {
        setshowMsg(true); 
    };

    const initialEntity = {
        id:-1,
        firstname: entity?.firstname,
        lastname: entity?.lastname,
        gender:entity?.gender,
        dateofbirth: entity?.dateofbirth,
        profileimageurl: entity?.profileimageurl,
    }

    function handleProfileImage(e) {
        if (e.target.files[0]) {
            setprofileimage(e.target.files[0]);
            setimageURL(props.auth.uid + "/ProfileImage." + e.target.files[0].name.split('.').pop());
        }
    }

    function UploadProfileImage() {
        let stacklen = 1;
        setLoading(true);
        try {
            const pState = {
                id:-1,
                firstname: firstnameRef.current.value,
                lastname: lastnameRef.current.value,
                gender: genderRef.current.value,
                dateofbirth: firebase.firestore.Timestamp.fromDate(new Date(dateofbirthRef.current.value)),
                profileimageurl:profileimageurl,
            }

            if (imageURL === '') {
                props.updateprofile(props.auth, pState, props.auth.uid)
                handleShowMsg();
                setLoading(false);
                return '';
            } else {
                const storage = getStorage();
                stacklen = 2;
                const storageRef = ref(storage, imageURL);            
                // save to firebase Storage
                uploadBytes(storageRef, profileimage).then((snapshot) => {
                    stacklen = 8;
                    getDownloadURL(snapshot.ref).then((pdownloadURL) => {
                        stacklen = 9;
                        profileimageurl = pdownloadURL;
                        if ((profileimageurl === '') || (profileimageurl === undefined)) {
                            console.log('Profile Image Report Error - Upload file missing. ');
                            return; 
                        }            
                        pState.profileimageurl = profileimageurl;
                        props.updateprofile(props.auth, pState, props.auth.uid)
                        handleShowMsg();
                    });
                    setLoading(false);
                    return profileimageurl;
                })
            }
        } catch (error) {
            console.log('Profile Image Error - ' + stacklen + ' - ' + error);
            setLoading(false);
            return profileimageurl;
        }
    }    


    function handleSubmit(e) {
        e.preventDefault();
        if (dateofbirthRef.current.value === '') {
            var defaultDate = new Date().toISOString().split("T")[0];
            dateofbirthRef.current.value = defaultDate;
        }

        UploadProfileImage();
    }

    return (
        <div style={styles.MainBGDivNoAlign}>
            <div style={styles.DashboardContainer}>

            <Modal style={{background:'transparent'}} show={showMsg} backdrop="static" size="sm" aria-labelledby="contained-modal-title-vcenter" centered onHide={handleCloseMsg}>
                <Modal.Header closeButton>
                <Modal.Title>Message</Modal.Title>
                </Modal.Header>
                <Modal.Body>Profile saved successfully!</Modal.Body>
                <Modal.Footer>
                <Button variant="primary" onClick={handleCloseMsg}>
                    Close
                </Button>
                </Modal.Footer>
            </Modal>

            <form onSubmit={handleSubmit}>
                <Card className="text-left">
                        <Card.Header className='text-center'> 
                            <Card.Title>
                                <div>
                                    <Table responsive="sm">
                                        <tbody>
                                        <tr>
                                            <td style={{textAlign:'left', width:'60%'}}><h3 style={styles.SubHeader}>Update {entity?.firstname}'s Profile</h3></td>
                                            <td style={{textAlign:'right', width:'15%'}}><Button disabled={loading} type='submit' style={styles.CDButton50}>Save</Button></td>
                                            <td style={{textAlign:'center', width:'15%'}}><Button style={styles.CDButton50} onClick={() => navigate("/")}>Cancel</Button></td>
                                        </tr>
                                        </tbody>
                                    </Table>                            
                                </div>
                            </Card.Title>
                        </Card.Header>                   
                        <CardBody>
                            <div>    
                                <Table responsive="sm">
                                    <tbody>
                                    <tr>
                                        <td style={{textAlign:'left', width:'50%'}}>
                                            <div className='imput-field'>
                                                <label htmlFor="firstname">Email</label>
                                                <input id="firstname" type="email" disabled ref={firstnameRef} defaultValue={initailemail}/>
                                            </div>
                                        </td>
                                        <td style={{textAlign:'left', width:'20%'}}>
                                            <div className='imput-field'>
                                                <label htmlFor="profileImage">Profile Image</label>
                                                <input id="profileImage" accept=".jpg, .png, .gif" type="file" onChange={handleProfileImage}/>
                                            </div>
                                        </td>
                                        <td style={{textAlign:'left', width:'20%'}}>
                                            <div className='imput-field'>
                                                {((profileimageurl === undefined) || (profileimageurl === "")) ? 
                                                    <span class="material-symbols-outlined" style={{color:grey, fontSize:'60px'}}>account_circle</span>
                                                    :
                                                    <Image style={styles.Image100} src={profileimageurl} border roundedCircle />
                                                }                                                
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{textAlign:'left', width:'50%'}}>
                                            <div className='imput-field'>
                                                <label htmlFor="firstname">First Name</label>
                                                <input id="firstname" type="text" ref={firstnameRef} defaultValue={entity?.firstname}/>
                                            </div>
                                        </td>
                                        <td style={{textAlign:'left', width:'50%'}}>
                                            <div className='imput-field'>
                                                <label htmlFor="lastname">Last Name</label>
                                                <input id="lastname" type="text" ref={lastnameRef}  defaultValue={entity?.lastname}/>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{textAlign:'left', width:'50%'}}>
                                        <div className='imput-field'>
                                            <label>Gender</label>
                                                <select id="gender" class="browser-default" defaultValue={entity?.gender} ref={genderRef} >
                                                    <option value="" disabled >Choose your option</option>
                                                    <option value="M">Male</option>
                                                    <option value="F">Female</option>
                                                    <option value="N">Choose not to share</option>
                                                </select>
                                            </div>
                                        </td>
                                        <td style={{textAlign:'left', width:'50%'}}>
                                            <div className='imput-field'>
                                                <label htmlFor="dateofbirth">Date of Birth</label>
                                                <input id="dateofbirth" type="date" ref={dateofbirthRef} defaultValue={dobDefault}/>
                                            </div>                    
                                        </td>
                                    </tr>
                                    </tbody>
                                </Table>                            
                            </div>

                        </CardBody>
                        <Card.Footer className="text-right">
                        </Card.Footer>
                </Card>
            </form>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    //console.log(state);
    //const ownentities = state.firestore.ordered.entities ? state.firestore.ordered.entities : state.entity.entities;
    //const ownwellness = state.firestore.ordered.wellness ? state.firestore.ordered.wellness : [];
    //console.log(ownentities);
    //console.log(ownwellness);
    return {
      //entities: ownentities,
      //wellness: ownwellness,
      auth: state.firebase.auth,
      profile: state.firebase.profile
    }
}
  
const mapDispatchToProps = (dispatch) => {
    return {
        updateprofile: (currentUser, user, userid) => dispatch(updateprofile(currentUser, user, userid))
    }
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    firestoreConnect(state => {
        const puid = (state.auth.uid != undefined) ? state.auth.uid : 'blank user';
        return [
          { 
            collection: 'entities',
            where: ['createdbyuser', '==', puid],
          },
          ]  
        }
      ),    
)(UpdateProfile)

